import React from 'react';
import './App.css';
import Barra from './barra';

const cvUrl = 'https://corpstudios.s3.us-east-1.amazonaws.com/CV-Johnatan+Mena.pdf';

function Curriculum() {
  return (
    <div className="page-shell">
      <Barra />

      <main className="resume-page">
        <section className="resume-hero">
          <p className="eyebrow">Curriculum profesional</p>
          <h1>Johnatan Mena Salcedo</h1>
          <p>
            Ingeniero de Software y Biomédico, especialista en IoT y consultoría TI.
          </p>
          <div className="resume-actions">
            <a className="primary-action" href={cvUrl} target="_blank" rel="noreferrer">
              Abrir PDF
            </a>
            <a className="secondary-action" href={cvUrl} download>
              Descargar
            </a>
          </div>
        </section>

        <section className="resume-viewer" aria-label="Vista previa del curriculum">
          <embed
            src={cvUrl}
            title="Curriculum de Johnatan Mena Salcedo"
            type="application/pdf"
          />
        </section>
      </main>

      <footer className="site-footer">
        <div className="footer-inner">
          <div>
            <p className="eyebrow">Hagamoslo real</p>
            <h2>Transformemos ideas en productos utiles.</h2>
          </div>

          <div className="footer-grid">
            <div>
              <h3>Contacto</h3>
              <p>johnatanmenasalcedo@gmail.com</p>
              <p>3146148505</p>
            </div>
            <div>
              <h3>BIT</h3>
              <p>www.beaconsiottechnologies.com</p>
              <p>beaconsiottechnologies@gmail.com</p>
            </div>
          </div>
        </div>
        <div className="copy">2026, &copy; Johnatan Mena</div>
      </footer>
    </div>
  );
}

export default Curriculum;
